import React, { useEffect, useState } from 'react';

import { useMsal } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import Header from '../component/Header';
import Spinner from '../component/Spinner';
import { getBuildStatusData } from '../api/auth';
import dayjs from 'dayjs';

function BuildStatusMUSe() {

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const navigate = useNavigate();

    const [isShow, setIsShow] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [dataHeader, setDataHeader] = useState(null);
    const [date, setDate] = useState('');
    const [data, setData] = useState(null);

    useEffect(() => {
        if (!activeAccount) {
            navigate("/");
        }
    }, [activeAccount]);

    useEffect(() => {
        (async () => {
            await fetchData();
        })();
    }, [refresh]);

    useEffect(() => {
        // Set up an interval to fetch data every 30 seconds
        const intervalId = setInterval(() => {
            fetchData();
        }, 1000 * 30); // 30 seconds

        // Clean up the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, []);

    const fetchData = async () => {
        try {
            setIsShow(true);
            const result = await getBuildStatusData("MUSe");
            console.log('result', result);
            if (result.ok === true) {
                setDataHeader(result?.data?.filter(v => v?.ITEM === "TITLE01"));
                setData(result?.data?.filter(v => v?.ITEM !== "TITLE01"));
                setDate(result.date);
            } else {
                alert("API CALL FAIL");
            }
        } catch (error) {
            console.log('error', error);
            alert(error.message);
        } finally {
            setIsShow(false);
        }
    }

    return (
        <>
            <Spinner isShow={isShow} />
            <Header setRefresh={setRefresh} />
            <div className='p-1 text-md bg-white dark:bg-black text-black dark:text-white'>
                <div className="flex flex-row justify-between">
                    <div className="font-bold">
                        Build Status (MUSe)
                    </div>
                    <div className={`${((new Date().getTime() - new Date(date).getTime()) / (1000 * 60)) > 10 ? "bg-red-500" : ""}`}>
                        {dayjs(date).format('MMM, D YYYY(ddd) HH:mm A')}
                    </div>
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center text-gray-500 border border-collapse border-white">
                        <tbody className="bg-white dark:bg-black text-black dark:text-white">
                            <tr className="bg-gray-300 dark:bg-[#1D3FA3]">
                                <th scope="col" rowSpan={2} className="border py-2" style={{ width: '25%' }}>

                                </th>
                                <th scope="col" colSpan={2} className="border py-2" style={{ width: '75%' }}>
                                    BSA
                                </th>
                            </tr>
                            <tr className="bg-gray-300 dark:bg-[#1D3FA3]">
                                <th scope="col" className="border py-2" style={{ width: '37.5%' }}>
                                    {dataHeader?.[0]?.VALUE01}
                                </th>
                                <th scope="col" className="border py-2" style={{ width: '37.5%' }}>
                                    {dataHeader?.[0]?.VALUE02}
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center text-gray-500 border border-collapse border-white">
                        <tbody className="bg-white dark:bg-black text-black dark:text-white">
                            {data && data.map((v, i) => {
                                return (
                                    <tr key={i} className={`bg-white dark:bg-black text-black dark:text-white border-b`}>
                                        <td scope="row" className={`border py-2 font-medium bg-gray-300 dark:bg-[#1D3FA3]`}
                                            style={{ width: '25%' }}>
                                            {v.ITEM}
                                        </td>
                                        <td className="border py-2" style={{ width: '37.5%' }}>
                                            {v.VALUE01 ?? 0}
                                        </td>
                                        <td className="border py-2" style={{ width: '37.5%' }}>
                                            {v.VALUE02 ?? 0}
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default BuildStatusMUSe;
